/**
 * AnnouncementAnalyticService
 * Service for managing announcement analytics
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for announcement analytic CRUD operations
 */
export class AnnouncementAnalyticService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AnnouncementAnalyticService.DEFAULT_SERVICE_PATH,
            basePath: AnnouncementAnalyticService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all analytics for a specific announcement
     * GET /api/announcement-analytics/by-announcement/{announcementId}
     * @param announcementId - Announcement ID
     * @returns Array of announcement analytics
     */
    async getByAnnouncementId(announcementId) {
        const response = await this.getByAnnouncementIdRaw(announcementId);
        return response.data ?? [];
    }
    /**
     * Get all analytics for a specific announcement (raw response)
     * @param announcementId - Announcement ID
     */
    getByAnnouncementIdRaw(announcementId) {
        const url = this.buildUrl(`by-announcement/${announcementId}`);
        return this.http.get(url);
    }
}
AnnouncementAnalyticService.DEFAULT_SERVICE_PATH = 'announcements';
AnnouncementAnalyticService.BASE_PATH = 'api/announcement-analytics';
//# sourceMappingURL=AnnouncementAnalyticService.js.map